import background from "../../images/background.png";

export const Footer = () => {
    return (
        <div className="fixed left-0 bottom-1 z-0">
            <img src={background} alt="" className="lg:w-[20vw] w-[50vw]" />
        </div>
    );
};